import React from 'react'
import { useState, useEffect } from 'react';
import Axios from 'axios'

import Navbar from '../components/navbar'


export default function Homepage({loginDetail}) {
    Axios.defaults.withCredentials = true
    const [data, setData] = useState([])


    const fetchData = () => {
        Axios.get("/api/data").then((response)=>{
            if (response.data) {
                console.log(response.data)
                setData(response.data)
            }
        })
    }

    const handleDelete = async(id) => {
        Axios.delete(`/api/data/${id}`).then((response)=>{
            if (response.data) {
                fetchData()
            }
        })
    }

    useEffect(() => {
        fetchData()
      }, []);


    return (
        <div className="home-container">
            <div>
                <Navbar loginDetail={loginDetail} />
            </div>
            <div className="body-container">
                <div className="message">
                    Welcome to the website.

                    <br/>
                    <br/>
                    <a href='/privacyPolicy.html' target='_blank'>Privacy Policy</a>
                    <a href='/termsAndConditions.html' target='_blank'>T&C</a>
                    {loginDetail.id && <p>Data: </p>}
                    <br/>
                    {loginDetail.id && <button onClick={fetchData}>Refresh</button>}
                    <div>
                        {data.map(function(d, idx){
                            return (<li key={idx}><h3>{d.title}<button onClick={() => handleDelete(d.id)} >X</button></h3><p>{d.msg}</p><p>{d.date}</p></li>)
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}